import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PrevUrlService {
  private prevUrl = new BehaviorSubject('');
  currentUrl = this.prevUrl.asObservable();

  constructor() { }

  updateUrl(url: string) {
    this.prevUrl.next(url);
  }
}
